import { NbMenuItem } from '@nebular/theme';

export const MENU_ITEMS: NbMenuItem[] = [
  {
    title: 'Carte du monde',
    icon: 'globe',
    link: '/pages/home-map',
    home: true,
  },
  {
    title: 'Informations Par Pays',
    icon: 'compass',
    link: '/pages/world-informations',
  },
  {
    title: 'Où Partir ? ',
    icon: 'sun',
    link: '/pages/calendar-search',
  },
  {
    title: 'Region',
    group: true,
  },
  {
    title: 'Afrique',
    icon: 'flag',
    link: '/pages/afrique',
    data: 'afrique',
  },
  {
    title: 'Amerique',
    icon: 'flag',
    children: [
      {
        title: 'Amérique',
        link: '/pages/amerique',
        data: 'amerique',
      },
      {
        title: 'Amérique du Nord',
        link: '/pages/amerique-du-nord',
        data: 'amerique-du-nord',
      },
      {
        title: 'Amérique du Sud',
        link: '/pages/amerique-du-sud',
        data: 'amerique-du-sud',
      },
      {
        title: 'Amérique Centrale',
        link: '/pages/amerique-centrale',
        data: 'amerique-centrale',
      },
    ],
  },
  {
    title: 'Asie',
    icon: 'flag',
    link: '/pages/asie',
  },
  {
    title: 'Caraibes',
    icon: 'flag',
    link: '/pages/caraibes',
  },
  {
    title: 'Europe',
    icon: 'flag',
    link: '/pages/europe',
    data: 'europe',
  },
  {
    title: 'Moyen-Orient',
    icon: 'flag',
    link: '/pages/moyen-orient',
  },
  {
    title: 'Océan Atlantique',
    icon: 'flag',
    link: '/pages/ocean-atlantique',
  },
  {
    title: 'Océan Indien',
    icon: 'flag',
    link: '/pages/ocean-indien',
  },
  {
    title: 'Océan Pacifique',
    icon: 'flag',
    link: '/pages/ocean-pacifique',
  },
];
